import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';
import { APIS } from 'scbk-shared-module/constants';
import {
  KycVldGetCddMotpPurposeCheckViewModelRequest,
  KycVldGetCddMotpPurposeCheckViewModelResponse,
} from '../../types/api/utlFncCddType';

import {
  KycVldCddCustInfoModelRequest,
  KycVldCddCustInfoModelResponse,
  KycVldCddCustInfoRequest,
  KycVldCddCustInfoResponse,
  KycVldCddOverDueModelRequest,
  KycVldCddOverDueModelResponse,
  KycVldCheckCddFatcaRequest,
  KycVldCheckCddFatcaResponse,
  KycVldCheckCddStatusRequest,
  KycVldCheckCddStatusResponse,
  KycVldCheckIsAbroadResponse,
  KycVldGetCustContactCenterModelRequest,
  KycVldGetCustContactCenterModelResponse,
  KycVldGetEJusoRequest,
  KycVldGetEJusoResponse,
  KycVldInquiryExposedPersonRequest,
  KycVldInquiryExposedPersonResponse,
  KycVldKCddAdditionalDocViewModelRequest,
  KycVldKCddAdditionalDocViewModelResponse,
  KycVldKCddCompleteViewModelRequest,
  KycVldKCddCompleteViewModelResponse,
  KycVldKCddEdocCreateModeDataRequest,
  KycVldKCddEdocCreateModeDataResponse,
  KycVldKCddEdocMergeRcvryRequest,
  KycVldKCddEdocMergeRcvryResponse,
  KycVldKCddEdocMergeRequest,
  KycVldKCddEdocMergeResponse,
  KycVldKCddEdocSaveServerRequest,
  KycVldKCddEdocSaveServerResponse,
  KycVldKCddViewModelRequest,
  KycVldKCddViewModelResponse,
  KycVldPrcKCddRegisterStatusRequest,
  KycVldPrcKCddRegisterStatusResponse,
  KycVldPurposeCheckModelRequest,
  KycVldPurposeCheckModelResponse,
  KycVldRegistCddFatcaRequest,
  KycVldRegistCddFatcaResponse,
  KycVldRegistDestructionCustInfoRequest,
  KycVldRegistDestructionCustInfoResponse,
} from '../../types';

// CDD API Hook 정의 파일

// [고객확인제도] CDD OverDue 고객 처리 화면 Model 조회 [AS-IS MA3CMMBIZ014_101S]
// URL : /services/kyc/validate/inquiryCddOverDueModel
// com.scbank.api.services.controller.KycValidateController#getCddOverDueModel
export function useCddOverDueModel(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldCddOverDueModelRequest,
    KycVldCddOverDueModelResponse
  >,
) {
  return useRestPost<KycVldCddOverDueModelRequest, KycVldCddOverDueModelResponse>(
    {
      endpoint: APIS.services.kyc.validate.getCddOverDueModel,
    },
    mutationOptions,
  );
}

// [고객확인제도] 해외접속 IP여부 [AS-IS MA3CMMAAT003_201S]
// URL : /services/kyc/validate/inquiryCheckIsAbroad
// com.scbank.api.services.controller.KycValidateController#getCheckIsAbroad
export function useCheckIsAbroad(
  mutationOptions?: UseRestPostMutationOptions<void, KycVldCheckIsAbroadResponse>,
) {
  return useRestPost<void, KycVldCheckIsAbroadResponse>(
    {
      endpoint: APIS.services.kyc.validate.getCheckIsAbroad,
    },
    mutationOptions,
  );
}

// [고객확인제도] 고객정보확인변경 화면 Model 조회 [AS-IS MA3CMMBIZ014_101S]
// URL : /services/kyc/validate/inquiryCddCustInfoModel
// com.scbank.api.services.controller.KycValidateController#getCddCustInfoModel
export function useCddCustInfoModel(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldCddCustInfoModelRequest,
    KycVldCddCustInfoModelResponse
  >,
) {
  return useRestPost<KycVldCddCustInfoModelRequest, KycVldCddCustInfoModelResponse>(
    {
      endpoint: APIS.services.kyc.validate.getCddCustInfoModel,
    },
    mutationOptions,
  );
}

// [고객확인제도] 고객정보확인변경 저장[MA3CMMBIZ001_112S]
// URL : /services/kyc/validate/registCddCustInfo
// com.scbank.api.services.controller.KycValidateController#registCddCustInfo
export function useRegistCddCustInfo(
  mutationOptions?: UseRestPostMutationOptions<KycVldCddCustInfoRequest, KycVldCddCustInfoResponse>,
) {
  return useRestPost<KycVldCddCustInfoRequest, KycVldCddCustInfoResponse>(
    {
      endpoint: APIS.services.kyc.validate.registCddCustInfo,
    },
    mutationOptions,
  );
}

// [고객확인제도] CDD여부체크 [MA3CMMBIZ001_116S]
// URL : /services/kyc/validate/checkCddStatus
// com.scbank.api.services.controller.KycValidateController#getCheckCddStatus
export function useCheckCddStatus(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldCheckCddStatusRequest,
    KycVldCheckCddStatusResponse
  >,
) {
  return useRestPost<KycVldCheckCddStatusRequest, KycVldCheckCddStatusResponse>(
    {
      endpoint: APIS.services.kyc.validate.checkCddStatus,
    },
    mutationOptions,
  );
}

// [고객확인제도] 거래목적확인 화면 Model 조회 [AS-IS MA3CMMBIZ011_101S]
// URL : /services/kyc/validate/inquiryPurposeCheckModel
// com.scbank.api.services.controller.KycValidateController#getPurposeCheckModel
export function usePurposeCheckModel(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldPurposeCheckModelRequest,
    KycVldPurposeCheckModelResponse
  >,
) {
  return useRestPost<KycVldPurposeCheckModelRequest, KycVldPurposeCheckModelResponse>(
    {
      endpoint: APIS.services.kyc.validate.getPurposeCheckModel,
    },
    mutationOptions,
  );
}

// [고객확인제도] FATCA 여부 조회 [AS-IS MA3CMMBIZ001_102S]
// URL : /services/kyc/validate/inquiryCheckCddFatca
// com.scbank.api.services.controller.KycValidateController#getCheckCddFatca
export function useCheckCddFatca(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldCheckCddFatcaRequest,
    KycVldCheckCddFatcaResponse
  >,
) {
  return useRestPost<KycVldCheckCddFatcaRequest, KycVldCheckCddFatcaResponse>(
    {
      endpoint: APIS.services.kyc.validate.getCheckCddFatca,
    },
    mutationOptions,
  );
}

// [고객확인제도] FATCA 정보 등록 [AS-IS MA3CMMBIZ001_103S]
// URL : /services/kyc/validate/registCheckCddFatca
// com.scbank.api.services.controller.KycValidateController#getCheckCddFatca
export function useRegistCddFatca(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldRegistCddFatcaRequest,
    KycVldRegistCddFatcaResponse
  >,
) {
  return useRestPost<KycVldRegistCddFatcaRequest, KycVldRegistCddFatcaResponse>(
    {
      endpoint: APIS.services.kyc.validate.registCddFatca,
    },
    mutationOptions,
  );
}

// [고객확인제도] 파기대상고객정보 신규등록 [AS-IS MA3CMMBIZ001_114S]
// URL : /services/kyc/validate/registDistructionCustomer
// com.scbank.api.services.controller.KycValidateController#registDistructionCustomer
export function useRegistDistructionCustomer(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldRegistDestructionCustInfoRequest,
    KycVldRegistDestructionCustInfoResponse
  >,
) {
  return useRestPost<
    KycVldRegistDestructionCustInfoRequest,
    KycVldRegistDestructionCustInfoResponse
  >(
    {
      endpoint: APIS.services.kyc.validate.registDistructionCustomer,
    },
    mutationOptions,
  );
}

export function useExposedPerson(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldInquiryExposedPersonRequest,
    KycVldInquiryExposedPersonResponse
  >,
) {
  return useRestPost<KycVldInquiryExposedPersonRequest, KycVldInquiryExposedPersonResponse>(
    {
      endpoint: APIS.services.kyc.validate.inquiryExposedPerson,
    },
    mutationOptions,
  );
}

// [고객확인제도] K-CDD KAIS 통신 화면 모델 조회 [AS-IS MA3CMMBIZ028_101S]
// URL : /services/kyc/validate/inquiryKCddViewModel
// com.scbank.api.services.controller.KycValidateController#getKCddViewModel
export function useKCddViewModel(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldKCddViewModelRequest,
    KycVldKCddViewModelResponse
  >,
) {
  return useRestPost<KycVldKCddViewModelRequest, KycVldKCddViewModelResponse>(
    {
      endpoint: APIS.services.kyc.validate.getKCddViewModel,
    },
    mutationOptions,
  );
}

// [고객확인제도] K-CDD 접수등록(GNS)/처리상태조회(CRA) [AS-IS MA3CMMBIZ028_102S]
// URL : /services/kyc/validate/prcKCddRegisterStatus
// com.scbank.api.services.controller.KycValidateController#prcKCddSRegisterStatus
export function useKCddSRegisterStatus(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldPrcKCddRegisterStatusRequest,
    KycVldPrcKCddRegisterStatusResponse
  >,
) {
  return useRestPost<KycVldPrcKCddRegisterStatusRequest, KycVldPrcKCddRegisterStatusResponse>(
    {
      endpoint: APIS.services.kyc.validate.prcKCddRegisterStatus,
    },
    mutationOptions,
  );
}

// [고객확인제도] K-CDD KAIS 통신 완료 화면 모델 조회 [AS-IS MA3CMMBIZ028_201S]
// URL : /services/kyc/validate/inquiryKCddCompleteViewModel
// com.scbank.api.services.controller.KycValidateController#getKCddCompleteViewModel
export function useKCddCompleteViewModel(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldKCddCompleteViewModelRequest,
    KycVldKCddCompleteViewModelResponse
  >,
) {
  return useRestPost<KycVldKCddCompleteViewModelRequest, KycVldKCddCompleteViewModelResponse>(
    {
      endpoint: APIS.services.kyc.validate.getKCddCompleteViewModel,
    },
    mutationOptions,
  );
}

// [고객확인제도] 영문주소 조회 [AS-IS MA3MSCMNG005_203S]
// URL : /services/kyc/validate/inquiryGetEJuso
// com.scbank.api.services.controller.KycValidateController#getEJuso
export function useGetEJuso(
  mutationOptions?: UseRestPostMutationOptions<KycVldGetEJusoRequest, KycVldGetEJusoResponse>,
) {
  return useRestPost<KycVldGetEJusoRequest, KycVldGetEJusoResponse>(
    {
      endpoint: APIS.services.kyc.validate.getEJuso,
    },
    mutationOptions,
  );
}

// [고객확인제도] 고객컨택센터확인 화면 Model 데이터 조회 [AS-IS MA3CMMBIZ012_301S]
// URL : /services/kyc/validate/inquiryCusContactCenterViewModel
// com.scbank.api.services.controller.KycValidateController#getCustContactCenterViewModel
export function useCustContactCenterViewModel(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldGetCustContactCenterModelRequest,
    KycVldGetCustContactCenterModelResponse
  >,
) {
  return useRestPost<
    KycVldGetCustContactCenterModelRequest,
    KycVldGetCustContactCenterModelResponse
  >(
    {
      endpoint: APIS.services.kyc.validate.getCusContactCenterViewModel,
    },
    mutationOptions,
  );
}

// [고객확인제도] 개인사업자 CDD 불가 화면 Model 데이터 조회 [AS-IS MA3CMMSPU001_100S]
// URL : /services/kyc/validate/inquiryCddSoleProprietorBlockModel
// com.scbank.api.services.controller.KycValidateController#getCddSoleProprietorBlockModel
export function useCddSoleProprietorBlockModel(
  mutationOptions?: UseRestPostMutationOptions<null, null>,
) {
  return useRestPost<null, null>(
    {
      endpoint: APIS.services.kyc.validate.getCddSoleProprietorBlockModel,
    },
    mutationOptions,
  );
}

// [고객확인제도] 추가서류제출(마이데이터 활용) 화면 Model 데이터 조회 [AS-IS MA3CMMBIZ032_101S]
// URL : /services/kyc/validate/inquiryCddAdditionalDocViewModel
// com.scbank.api.services.controller.KycValidateController#getCddCddAdditionalDocViewModel
export function useCddAdditionalDocViewModel(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldKCddAdditionalDocViewModelRequest,
    KycVldKCddAdditionalDocViewModelResponse
  >,
) {
  return useRestPost<
    KycVldKCddAdditionalDocViewModelRequest,
    KycVldKCddAdditionalDocViewModelResponse
  >(
    {
      endpoint: APIS.services.kyc.validate.getCddAdditionalDocViewModel,
    },
    mutationOptions,
  );
}

// [고객확인제도] [고객확인제도] 대출 PDF MERGE 대상 조회후 데이터 재 세팅하여 Client에 전달 [AS-IS MA3CMMEDC001_101S]
// URL : /services/kyc/validate/inquiryPrcKCddEdocMerge
// com.scbank.api.services.controller.KycValidateController#getPrcKCddEdocMerge
export function useCddEdocMerge(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldKCddEdocMergeRequest,
    KycVldKCddEdocMergeResponse
  >,
) {
  return useRestPost<KycVldKCddEdocMergeRequest, KycVldKCddEdocMergeResponse>(
    {
      endpoint: APIS.services.kyc.validate.getPrcKCddEdocMerge,
    },
    mutationOptions,
  );
}

// [고객확인제도] 대출 PDF MERGE 대상 조회후 복구 테이블에 저장 [AS-IS MA3CMMEDC001_102S]
// URL : /services/kyc/validate/prcKCddEdocMergeRcvry
// com.scbank.api.services.controller.KycValidateController#prcKCddEdocMergeRcvry
export function useCddEdocMergeRcvry(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldKCddEdocMergeRcvryRequest,
    KycVldKCddEdocMergeRcvryResponse
  >,
) {
  return useRestPost<KycVldKCddEdocMergeRcvryRequest, KycVldKCddEdocMergeRcvryResponse>(
    {
      endpoint: APIS.services.kyc.validate.prcKCddEdocMergeRcvry,
    },
    mutationOptions,
  );
}

// [고객확인제도] Motp 거래 목적화면 Model 데이터 조회 [AS-IS MA3ACTOPN001_104S]
// URL : /services/kyc/validate/useGetCddMotpPurposeCheckViewkModel
// com.scbank.api.services.controller.KycValidateController#getCddMotpPurposeCheckViewkModel
export function useGetCddMotpPurposeCheckViewkModel(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldGetCddMotpPurposeCheckViewModelRequest,
    KycVldGetCddMotpPurposeCheckViewModelResponse
  >,
) {
  return useRestPost<
    KycVldGetCddMotpPurposeCheckViewModelRequest,
    KycVldGetCddMotpPurposeCheckViewModelResponse
  >(
    {
      endpoint: APIS.services.kyc.validate.getCddMotpPurposeCheckViewModel,
    },
    mutationOptions,
  );
}

// [고객확인제도] 전자문서 생성후 후처리 작업 진행-대출 전자문서 WAS에 저장 [AS-IS MA3CMMEDC001_200S]
// URL : /services/kyc/validate/prcKCddEdocSaveServer
// com.scbank.api.services.controller.KycValidateController#prcKCddEdocSaveServer
export function useCddEdocSaveServer(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldKCddEdocSaveServerRequest,
    KycVldKCddEdocSaveServerResponse
  >,
) {
  return useRestPost<KycVldKCddEdocSaveServerRequest, KycVldKCddEdocSaveServerResponse>(
    {
      endpoint: APIS.services.kyc.validate.prcKCddEdocSaveServer,
    },
    mutationOptions,
  );
}

// [고객확인제도] Clip전자문서 뷰어 - Create Mode 데이터 [AS-IS MA3CMMEDC001_100S]
// URL : /services/kyc/validate/inquiryKCddEdocCreateModeData
// com.scbank.api.services.controller.KycValidateController#getKCddEdocCreateModeData
export function useKCddEdocCreateModeData(
  mutationOptions?: UseRestPostMutationOptions<
    KycVldKCddEdocCreateModeDataRequest,
    KycVldKCddEdocCreateModeDataResponse
  >,
) {
  return useRestPost<KycVldKCddEdocCreateModeDataRequest, KycVldKCddEdocCreateModeDataResponse>(
    {
      endpoint: APIS.services.kyc.validate.getKCddEdocCreateModeData,
    },
    mutationOptions,
  );
}
